module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_cupcake.e3f112fd.png";